<template>
    <v-row class="live-card px-0 py-1 rounded-lg" align="center" justify="center">
        <v-col cols="2" class="px-0 mx-0 custom-teal-text font-weight-bold" style="font-size: 1.5rem;">
            {{ type }}
        </v-col>
        <v-col cols="3" align="center" class="px-1 py-0 my-0">
            <img
                :src="`${assetsUrl}/${match.team1?.logo}`"
                class="live-logo"
                height="80px"
                width="auto"
                contain
            >
            <div class="text-h5 font-weight-bold" :style="`width: 100%; border-top: 8px solid ${colors.team1}; font-size: 1.5rem;`">{{ team1Stat }}</div>
        </v-col>
        <v-col cols="4" class="pr-0 py-0 pb-3">
            <doughnut-chart
                :chart-data="{
                    datasets: [
                        {
                            backgroundColor: [colors.team2, colors.team1],
                            // a thin light edge keeps the two parts apart on the dark card
                            borderColor: 'rgba(255, 255, 255, 0.85)',
                            borderWidth: 2,
                            data: [team2Stat, team1Stat]
                        }
                    ]
                }"
                :type="type"
            />
        </v-col>
        <v-col cols="3" align="center" class="px-1 py-0 my-0">
            <img
                :src="`${assetsUrl}/${match.team2?.logo}`"
                class="live-logo"
                height="80px"
                width="auto"
                contain
            >
            <div class="font-weight-bold" :style="`width: 100%; border-top: 8px solid ${colors.team2}; font-size: 1.5rem;`">{{ team2Stat }}</div>
        </v-col>
    </v-row>
</template>

<script>
    import DoughnutChart from '@/components/Doughnut.vue'
    import { BACKGROUNDS, getMatchColors } from '@/utils/colors'

    export default {
        components: {
            DoughnutChart
        },
        props: {
            type: {
                type: String,
                default: null
            },
            match: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com',
                team1Stat: 0,
                team2Stat: 0
            }
        },
        computed: {
            // team colours that show on the dark card and differ from each other
            colors() {
                return getMatchColors(this.match.team1, this.match.team2, BACKGROUNDS.dark)
            }
        },
        watch: {
            match: {
                handler() {
                    this.team1Stat = this.getTeam1Stat()
                    this.team2Stat = this.getTeam2Stat()
                    this.$forceUpdate()
                },
                deep: true,
                immediate: true
            }
        },
        methods: {
            getTeam1Stat() {
                if (this.type === 'T.R.') {
                    return (this.match.team1.offensiveRebounds + this.match.team1.defensiveRebounds)
                } else if (this.type === 'AST') {
                    return this.match.team1.assists
                } else if (this.type === 'STL') {
                    return this.match.team1.steals
                } else if (this.type === 'BLK') {
                    return this.match.team1.blockedShots
                } else if (this.type === 'TO') {
                    return this.match.team1.turnovers
                } else if (this.type === '1P') {
                    return ((this.match.team1.freeThrowsMade / this.match.team1.freeThrowAttempts) * 100).toFixed(1)
                } else if (this.type === '2P') {
                    return ((this.match.team1.twoPointsMade / this.match.team1.twoPointAttempts) * 100).toFixed(1)
                } else if (this.type === '3P') {
                    return ((this.match.team1.threePointsMade / this.match.team1.threePointAttempts) * 100).toFixed(1)
                }
            },
            getTeam2Stat() {
                if (this.type === 'T.R.') {
                    return (this.match.team2.offensiveRebounds + this.match.team2.defensiveRebounds)
                } else if (this.type === 'AST') {
                    return this.match.team2.assists
                } else if (this.type === 'STL') {
                    return this.match.team2.steals
                } else if (this.type === 'BLK') {
                    return this.match.team2.blockedShots
                } else if (this.type === 'TO') {
                    return this.match.team2.turnovers
                } else if (this.type === '1P') {
                    return ((this.match.team2.freeThrowsMade / this.match.team2.freeThrowAttempts) * 100).toFixed(1)
                } else if (this.type === '2P') {
                    return ((this.match.team2.twoPointsMade / this.match.team2.twoPointAttempts) * 100).toFixed(1)
                } else if (this.type === '3P') {
                    return ((this.match.team2.threePointsMade / this.match.team2.threePointAttempts) * 100).toFixed(1)
                }
            }
        }
    }
</script>

<style>
    .v-progress-circular__info {
        display: block;
    }
</style>
